import React from 'react';

import { Container, ContainerInner, CopyRight, Country } from './FooterNew.styles';

const FooterNew = ({country, copyText}) => {
  return (
    <Container>
        <ContainerInner>
            <CopyRight>{copyText}</CopyRight>
            <Country>Country <span>{country}</span></Country>
        </ContainerInner>
    </Container>
  )
}

export default FooterNew;